/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GuestRoomReadAttributesGuestRoomInventory } from './guest-room-read-attributes-guest-room-inventory';
import { GuestRoomReadAttributesPrices } from './guest-room-read-attributes-prices';
import { GuestRoomReadAttributesThumbnail } from './guest-room-read-attributes-thumbnail';
/**
 * 
 * @export
 * @interface GuestRoomReadAttributes
 */
export interface GuestRoomReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    availabilityStatus?: GuestRoomReadAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    count?: number;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    index?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomReadAttributes
     */
    fictitious?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    immersiveUrl: string;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    minNights?: number;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuestRoomReadAttributes
     */
    occupancyTypes: Array<GuestRoomReadAttributesOccupancyTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    roomHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    roomLength?: number;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    roomWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    surfaceMeters?: number;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof GuestRoomReadAttributes
     */
    thumbnail: GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {Date}
     * @memberof GuestRoomReadAttributes
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GuestRoomReadAttributes
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    shortUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    availabilityQuota: number | null;
    /**
     * 
     * @type {Array<GuestRoomReadAttributesGuestRoomInventory>}
     * @memberof GuestRoomReadAttributes
     */
    guestRoomInventory?: Array<GuestRoomReadAttributesGuestRoomInventory>;
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomReadAttributes
     */
    includedInOrders?: boolean;
    /**
     * 
     * @type {Array<GuestRoomReadAttributesPrices>}
     * @memberof GuestRoomReadAttributes
     */
    prices?: Array<GuestRoomReadAttributesPrices>;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    totalMinNights: number | null;
}

/**
    * @export
    * @enum {string}
    */
export enum GuestRoomReadAttributesAvailabilityStatusEnum {
    Disabled = 'disabled',
    Private = 'private',
    Public = 'public'
}
/**
    * @export
    * @enum {string}
    */
export enum GuestRoomReadAttributesOccupancyTypesEnum {
    Single10 = 'single-1-0',
    Double20 = 'double-2-0',
    Double11 = 'double-1-1',
    Triple30 = 'triple-3-0',
    Triple21 = 'triple-2-1',
    Triple12 = 'triple-1-2',
    Quadruple40 = 'quadruple-4-0',
    Quadruple31 = 'quadruple-3-1',
    Quadruple22 = 'quadruple-2-2',
    Quadruple13 = 'quadruple-1-3',
    Quintuple50 = 'quintuple-5-0',
    Quintuple41 = 'quintuple-4-1',
    Quintuple32 = 'quintuple-3-2',
    Quintuple23 = 'quintuple-2-3',
    Quintuple14 = 'quintuple-1-4'
}

